/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/SlotActionsAPI',
	'underscore'
], (APIFactory, SlotActionsAPI, _) => {

	class SlotActions {

		constructor() {
			this.api = APIFactory.createAPI(this, [SlotActionsAPI]);
			this.providers = [];
		}

		registerProvider(name, provider) {
			this.providers[name] = provider;
		}

		getSlotActionList(dataSlotId, itemIndex, options) {
			const actionOptions = (options && options.actionOptions) || {};
			const actionsToKeep = (options && options.actionsToKeep) || [];

			let actions = [];
			for (let actionName in this.providers) {
				const feature = this.providers[actionName];
				if (feature.getSlotActionList) {
					let slotAction = null;
					try {
						slotAction = feature.getSlotActionList(dataSlotId, itemIndex, actionOptions[actionName]);
					} catch (e) {
						console.log(e);
					}
					if (!_.isEmpty(slotAction)) {
						actions.push(...slotAction);
					}
				}
			}

			// Filter actions if needed
			if (actionsToKeep.length) {
				actions = actions.filter(action => {
					// TODO We need to check all three of them for now because of some inconsistencies we have in our code.
					// New API's should use *name* to identify an action.
					return _.contains(actionsToKeep, action.id || action.group || action.name) || action.name === 'delete';
				});
			}

			return actions;
		}

		getAPI() {
			return this.api;
		}
	}

	return SlotActions;
});